import { Button } from '@/components/shared/Button';
import { useModalStore } from '@/store';

import cn from './styles.module.sass';

export const ErrorPurchaseContent = () => {
    const { setIsPurchaseErrorOpen, isYooMoneyError } = useModalStore();

    return (
        <div className={cn.container}>
            <img src="/images/main/error.svg" alt="" />
            <h2>Ошибка {isYooMoneyError ? 'оплаты' : 'активации'}</h2>
            <p>
                Деньги будут возвращены на счет, с которого производилась оплата. Пожалуйста,
                повтори попытку позже
            </p>
            <Button onClick={() => setIsPurchaseErrorOpen(false)}>Закрыть</Button>
        </div>
    );
};
